import React, { useState } from "react";
import Input from "../../components/Input";
import InputSelect from "../../components/InputSelect";
import InputMask from "../../components/InputMask";
import { Row, Col, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { normalizeText, normalizeTextWithNumber } from "../../utils/removeMask";
import { useParams } from "react-router-dom";

export default function FormAddress({
  register,
  errors,
  control,
  onPrevious,
  onNext,
  loading,
  setValue,
}) {
  const { paymentGroupId, type = false, currentUserId, formStep } = useParams();

  const [personalNeighborhood, setPersonalNeighborhood] = useState();
  const [personalStreet, setPersonalStreet] = useState();
  const [personalComplement, setPersonalComplement] = useState();

  function fnRemoveCaracterNeighborhood(e) {
    const value = normalizeTextWithNumber(e.target.value);
    setPersonalNeighborhood(value);
  }

  function fnRemoveCaracterStreet(e) {
    const value = normalizeTextWithNumber(e.target.value);
    setPersonalStreet(value);
  }

  function fnRemoveCaracterComplement(e) {
    const value = normalizeTextWithNumber(e.target.value);
    setPersonalComplement(value);
  }

  async function getAddress(inputCep) {
    const cep = inputCep.toString().replace(/-/g, "");
    const cepValidation = /^[0-9]{8}$/;

    if (cepValidation.test(cep)) {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json`).then(
        (res) => res.json()
      );

      if (response.uf) {
        setValue("personalState", response.uf, { shouldValidate: true });
        setValue("personalStreet", response.logradouro, {
          shouldValidate: true,
        });
        setValue("personalCity", response.localidade, { shouldValidate: true });
        setValue("personalNeighborhood", response.bairro, {
          shouldValidate: true,
        });
      } else {
        [
          "personalState",
          "personalAddress",
          "personalCity",
          "personalNeighborhood",
        ].forEach((field) => setValue(field, "", { shouldValidate: true }));
      }
    } else {
      [
        "personalState",
        "personalAddress",
        "personalCity",
        "personalNeighborhood",
      ].forEach((field) => setValue(field, "", { shouldValidate: true }));
    }
  }

  return (
    <div key="formAddress">
      <Row gutter={16} className="__auth-mb-25">
        {type === "legalPerson" && (
          <Col xs={24}>
            <div style={{ margin: "0px 10px", marginBottom: "40px" }}>
              <Typography.Title level={4}>
                Preencha com os dados do administrador da sua conta PJ
              </Typography.Title>
            </div>
          </Col>
        )}
        <Col xs={24} sm={24} md={24} lg={12}>
          <InputMask
            key="personalZipCode"
            name="personalZipCode"
            placeholder="Digite seu cep"
            label="CEP"
            error={errors.personalZipCode?.message}
            control={control}
            required
            mask="99999-999"
            onChange={({ target }) => getAddress(target.value)}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <InputSelect
            control={control}
            key="personalState"
            label="Estado"
            placeholder="Selecione seu estado"
            name="personalState"
            required
            error={errors.personalState?.message}
            options={[
              { value: "AC", label: "Acre" },
              { value: "AL", label: "Alagoas" },
              { value: "AP", label: "Amapá" },
              { value: "AM", label: "Amazonas" },
              { value: "BA", label: "Bahia" },
              { value: "CE", label: "Ceará" },
              { value: "DF", label: "Distrito Federal" },
              { value: "ES", label: "Espírito Santo" },
              { value: "GO", label: "Goías" },
              { value: "MA", label: "Maranhão" },
              { value: "MT", label: "Mato Grosso" },
              { value: "MS", label: "Mato Grosso do Sul" },
              { value: "MG", label: "Minas Gerais" },
              { value: "PA", label: "Pará" },
              { value: "PB", label: "Paraíba" },
              { value: "PR", label: "Paraná" },
              { value: "PE", label: "Pernambuco" },
              { value: "PI", label: "Piauí" },
              { value: "RJ", label: "Rio de Janeiro" },
              { value: "RN", label: "Rio Grande do Norte" },
              { value: "RS", label: "Rio Grande do Sul" },
              { value: "RO", label: "Rondônia" },
              { value: "RR", label: "Roraíma" },
              { value: "SC", label: "Santa Catarina" },
              { value: "SP", label: "São Paulo" },
              { value: "SE", label: "Sergipe" },
              { value: "TO", label: "Tocantins" },
            ]}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            key="personalCity"
            label="Cidade"
            placeholder="Digite sua cidade"
            register={register("personalCity")}
            required
            error={errors.personalCity?.message}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            key="personalNeighborhood"
            label="Bairro"
            value={personalNeighborhood}
            placeholder="Selecione seu bairro"
            register={register("personalNeighborhood")}
            required
            error={errors.personalNeighborhood?.message}
            // onChange={(e) => fnRemoveCaracterNeighborhood(e)}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={24}>
          <Input
            key="personalStreet"
            value={personalStreet}
            label="Logradouro"
            placeholder="Digite seu endereço (rua, avenida, etc)"
            register={register("personalStreet")}
            required
            error={errors.personalStreet?.message}
            // onChange={(e) => fnRemoveCaracterStreet(e)}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={6}>
          <Input
            key="personalNumber"
            label="Número"
            placeholder="Digite seu número"
            register={register("personalNumber")}
            required
            error={errors.personalNumber?.message}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={18}>
          <Input
            key="personalComplement"
            value={personalComplement}
            label="Complemento"
            placeholder="Digite seu complemento"
            register={register("personalComplement")}
            error={errors.personalComplement?.message}
            // onChange={(e) => fnRemoveCaracterComplement(e)}
          />
        </Col>
      </Row>

      <Row gutter={16} className="__signup-bottom-button">
        <Col xs={12}>
          <button
            type="button"
            className="__auth-button-outlined"
            onClick={onPrevious}
            disabled={loading}
          >
            Voltar
          </button>
        </Col>
        <Col xs={12}>
          <button
            type="button"
            className="__auth-button-primary"
            onClick={onNext}
            disabled={loading}
          >
            {loading ? <LoadingOutlined /> : "Próximo"}
          </button>
        </Col>
      </Row>
    </div>
  );
}
